module.exports = __webpack_public_path__ + "img/paw1.32344918.svg";